import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import PaymentForm from '../forms/PaymentForm';
import { SET_PREVIEW_DATA } from '../../state/lease_contract/types';
import PropTypes from 'prop-types';

const AccountForm = ({ form }) => {

  return (
    <React.Fragment>
      <Row justify="center">
        <Col xs={24} md={22} lg={18} xl={14}>
          <PaymentForm id="payment" form={form} />
        </Col>
      </Row>
    </React.Fragment>
  );
};

AccountForm.propTypes = {
  form: PropTypes.object,
};

const data = (state) => ({
  previewData: state.contract.previewData,
  contractFormData: state.contract.contractFormData,
});

const actions = (dispatch) => ({
  setPreview: (data) => dispatch({ type: SET_PREVIEW_DATA, payload: { ...data } }),
});

export default connect(data, actions)(AccountForm);